import React from 'react'
import PropTypes from 'prop-types'

class ChatroomTypeFilter extends React.Component {
  state = {
    chatroomTypeFilter: this.props.chatroomTypeFilter
  }

  changeChatroomTypeFilter = (e) => {
    this.setState({ chatroomTypeFilter: e.target.value })
    this.props.changeChatroomTypeFilter(e.target.value);
  }

  render() {
    var options = this.props.chatroomTypes.map(function(chatroomType) {
      return (
        <option
          key={chatroomType.id}
          value={chatroomType.id}
        >
          {chatroomType.type}
        </option>
      )
    })

    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Locations'
                value={this.state.chatroomTypeFilter}
                onChange={(e) => this.changeChatroomTypeFilter(e)}>
          <option value=''>
            All Chats
          </option>
          {options}
        </select>
      </div>
    )
  }
}

ChatroomTypeFilter.propTypes = {
  chatroomTypeFilter: PropTypes.string,
  chatroomTypes: PropTypes.array,
  selectClassName: PropTypes.string,
  changeChatroomTypeFilter: PropTypes.func
}

export default ChatroomTypeFilter
